module.exports = __webpack_public_path__ + "media/images/dividend/Cart-cef06c107b70d5bccb65492e0e8f5b9a.gif";